/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FolderWrapperWrapper_viewer$ref = any;
type HeartWrapper_viewer$ref = any;
type PortfolioFolderWrapper_viewer$ref = any;
export type SharedFavoritesProvider_viewer$ref = any;
export type SharedFavoritesProvider_viewer = {
    readonly " $fragmentRefs": FolderWrapperWrapper_viewer$ref & HeartWrapper_viewer$ref & PortfolioFolderWrapper_viewer$ref;
    readonly " $refType": SharedFavoritesProvider_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "selectedItemIds",
        "variableName": "selectedItemIds"
    } as any), v1 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v2 = [
        (v0 /*: any*/),
        ({
            "kind": "Variable",
            "name": "shouldFillInFolder",
            "variableName": "shouldFillInFolder"
        } as any),
        (v1 /*: any*/)
    ];
    return {
        "kind": "Fragment",
        "name": "SharedFavoritesProvider_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "selectedItemIds",
                "type": "[String]",
                "defaultValue": []
            },
            {
                "kind": "LocalArgument",
                "name": "loadPortfolioData",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "shouldFillInFolder",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "userIds",
                "type": "[String]",
                "defaultValue": []
            }
        ],
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "FolderWrapperWrapper_viewer",
                "args": (v2 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "HeartWrapper_viewer",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "loadPortfolioData",
                        "variableName": "loadPortfolioData"
                    },
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "PortfolioFolderWrapper_viewer",
                "args": (v2 /*: any*/)
            }
        ]
    } as any;
})();
(node as any).hash = 'f3d7c56a2f194d3108b8366801428449';
export default node;
